import { Button } from '@onchainstudios/cryptoys-common-ui';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import brandmark from '../../img/brandmark.svg';
import wordmark from '../../img/wordmark.svg';
import useTimer from '../../utils/hooks/useTimer';
import { useQueryClient } from '@tanstack/react-query';
import styles from './Header.module.css';
import { deleteReservation } from '../../lib/cryptoys/drops/reservation';
import { useEffect, useState } from 'react';
import SkipLink from '../SkipLink';
import { CRYPTOYS_LEGION_KEY } from '../../constants';

const scrollFixedTrigger = 50;

function Header({
  hideTimer = false,
  hideCancelBtn = false,
  reservationId,
  isPurchaseInProgress = false
}) {
  const { timeLeft, isExpired } = useTimer();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const [isHeaderFixed, setIsHeaderFixed] = useState(
    window.scrollY > scrollFixedTrigger
  );
  const [isTimerDisabled, setIsTimerDisabled] = useState(false);

  const timerHiddenClass = hideTimer ? styles.timerHidden : '';

  useEffect(() => {
    function handleScroll(e) {
      setIsHeaderFixed(window.scrollY > scrollFixedTrigger);
    }
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (
      isExpired &&
      !isPurchaseInProgress &&
      !isTimerDisabled &&
      !hideTimer &&
      !location.pathname.includes('time-expired')
    ) {
      navigate({ pathname: '/time-expired', search: '?' + searchParams });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    timeLeft,
    isExpired,
    isPurchaseInProgress,
    isTimerDisabled,
    location.pathname
  ]);
  return (
    <>
      <SkipLink />
      <div
        className={`${styles.container} ${timerHiddenClass} ${
          isHeaderFixed ? styles.fixed : ''
        }`}
      >
        <a href={process.env.REACT_APP_HOME_URL} className={styles.logo}>
          <img src={brandmark} alt="Cryptoys brandmark" />
          <img className="mobileHide" src={wordmark} alt="Cryptoys wordmark" />
        </a>

        <div className={styles.headerCTAContainer}>
          {process.env.NODE_ENV === 'development' && (
            <>
              <Button
                variant="secondary"
                onPress={() => setIsTimerDisabled(!isTimerDisabled)}
              >
                {isTimerDisabled ? 'Enforce Time Limit' : 'Disable Time Limit'}
              </Button>
            </>
          )}

          {!hideTimer && !isTimerDisabled && (
            <p className={`bodySmReg ${styles.timer}`}>
              <span className={styles.timerLabel}>Time Limit</span>
              <span className={`bodyMdBold ${styles.timerText}`}>
                {timeLeft}
              </span>
            </p>
          )}

          {!hideCancelBtn && (
            <Button
              variant="secondary"
              onPress={() => {
                const id = reservationId ?? searchParams.get('reservationId');
                if (id) {
                  deleteReservation(id, searchParams.get('correlationId'));
                }
                queryClient.clear();
                sessionStorage.removeItem(CRYPTOYS_LEGION_KEY);
                window.location.replace(process.env.REACT_APP_DROPS_URL);
              }}
            >
              Cancel Purchase
            </Button>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
